/**
 * DropReasonModal Component
 * Modal for entering drop/skip reason
 */

import { useState } from 'react'
import Modal from './Modal'

const QUICK_REASONS = [
  'Boring',
  'Busy',
  'Not my mood',
  'Too long',
  '1話で脱落',
  'つまらない',
  '時間がない'
]

export function DropReasonModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  actionType = 'drop' // 'drop' or 'skip'
}) {
  const [reason, setReason] = useState('')

  const handleQuickReason = (quickReason) => {
    setReason(quickReason)
  }

  const handleConfirm = () => {
    onConfirm?.(reason)
    setReason('')
    onClose?.()
  }

  const handleClose = () => {
    setReason('')
    onClose?.()
  }

  const actionLabel = actionType === 'drop' ? 'ドロップ' : 'スキップ'

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={`${title} を${actionLabel}`}
      footer={
        <>
          <button className="btn btn-secondary" onClick={handleClose}>
            キャンセル
          </button>
          <button
            className={`btn ${actionType === 'drop' ? 'btn-danger' : 'btn-secondary'}`}
            onClick={handleConfirm}
          >
            {actionLabel}
          </button>
        </>
      }
    >
      <p style={{ marginBottom: '16px', color: 'var(--text-secondary)' }}>
        {actionType === 'drop'
          ? 'この作品を視聴リストから削除します。理由を記録しますか？'
          : 'この作品を一時的にスキップします。理由を記録しますか？'
        }
      </p>

      {/* Quick Reason Tags */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '16px' }}>
        {QUICK_REASONS.map((quickReason) => (
          <button
            key={quickReason}
            className={`filter-pill ${reason === quickReason ? 'active' : ''}`}
            onClick={() => handleQuickReason(quickReason)}
          >
            {quickReason}
          </button>
        ))}
      </div>

      {/* Custom Reason Input */}
      <div className="form-group">
        <label className="form-label">理由（任意）</label>
        <input
          type="text"
          className="form-input"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="自由入力..."
        />
      </div>
    </Modal>
  )
}

export default DropReasonModal
